import { Injectable } from '@angular/core';
import { ApiCallService } from './api-call.service';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { WebPage } from './../models/index';

@Injectable()
export class WebPageService implements Resolve<WebPage | void> {
  constructor(
    private apiCallService: ApiCallService,
    private router: Router
  ) {}

  getWebPage(pageType: string): Promise<WebPage> {
    return this.apiCallService.get('/web_pages/' + pageType);
  }

  resolve(route: ActivatedRouteSnapshot): Promise<WebPage | void> {
    const pageType = route.data['page_type'];
    const promise = this.getWebPage(pageType);

    if (promise) {
      promise.then(webPage => webPage)
        .catch(() => { this.router.navigate(['/']); });
    }

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/api/web-page.service.ts